import React from "react";
import TrackingPage from "./component/tracking";

export default function MainTracking() {
    return(
        <TrackingPage />
    )
}